<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      'open': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
<!--      <li v-for="(groupItem, index) in group.submenu" :key="index" v-if="!groupItem.permiso || permisos_actuales.includes(groupItem.permiso)">-->
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        v-if="canSeeChild(child.permiso)"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'
import axios from "@/libs/axios";
import { getPermisosLS } from '../../../../../../../shared/helpers'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permisos: [],
    }
  },
  created() {
    this.setToken()
  },
  mounted () {
    // this.setVerticalNavMenuWidth()
    this.getPermisos()
  },
  methods: {
    canSeeChild(permiso) {
      if (Array.isArray(permiso)) {
        return permiso.some(p => this.permisos.includes(p))
      }
      return this.permisos.includes(permiso)
    },
    getPermisos(){
      this.mostrarLoader = true

      const permisosLS = getPermisosLS();

      if (permisosLS) {
        this.permisos = permisosLS;
        return;
      }

      axios.post('api', {
        query: `
          {
            permisos{
              permisos_usuario: permisosUsuario,
              status,
              message,
            }
          }
        `,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.permisos.status === 'success') {
            if (response.data.data.permisos.permisos_usuario) {
              this.permisos = response.data.data.permisos.permisos_usuario
            }
          }
        }
      })
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    }
  },
}
</script>

<style>

</style>
